var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import VideoBox from './videoBox';
import { store, useAppDispatch } from '../../../../store';
import VirtualBackground from '../../../virtual-background/virtualBackground';
import BackgroundItems from './backgroundItems';
import { updateVirtualBackground } from '../../../../store/slices/bottomIconsActivitySlice';
const PreviewWebcam = ({ deviceId }) => {
    var _a;
    _react_refresh_temp_2();
    const [sourcePlayback, setSourcePlayback] = useState();
    const [show, setShow] = useState(false);
    const [previousDeviceId, setPreviousDeviceId] = useState();
    const [backgroundConfig, setBackgroundConfig] = useState();
    const [mediaStream, setMediaStream] = useState();
    const currentUser = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId;
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (previousDeviceId !== deviceId) {
            setShow(false);
            setPreviousDeviceId(deviceId);
        }
    }, [deviceId]);
    useEffect(() => {
        setShow(false);
        const changeView = () => {
            setTimeout(() => {
                setShow(true);
            }, 500);
        };
        if (sourcePlayback) {
            changeView();
        }
    }, [sourcePlayback]);
    useEffect(() => {
        return () => {
            if (mediaStream) {
                mediaStream.getTracks().forEach((track) => {
                    track.stop();
                });
            }
        };
    }, [mediaStream]);
    const displayVB = useCallback(() => {
        var _a;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            return false;
        }
        const room_features = (_a = store.getState().session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features;
        if (typeof (room_features === null || room_features === void 0 ? void 0 : room_features.allow_virtual_bg) !== 'undefined' &&
            room_features.allow_virtual_bg === false) {
            return false;
        }
        return true;
    }, []);
    const onSelectBg = (bg) => {
        dispatch(updateVirtualBackground(bg));
        if (bg.type === 'none') {
            setShow(false);
            setBackgroundConfig(undefined);
        }
        else {
            if (!show && deviceId) {
                setShow(true);
            }
            setBackgroundConfig(bg);
        }
    };
    return (_jsxs("div", { className: "mt-5", children: [deviceId ? (_jsx("div", { style: backgroundConfig
                    ? { height: '0.5px', width: '0.5px' }
                    : { width: 'auto' }, children: _jsx(VideoBox, { deviceId: deviceId, onSourcePlayback: setSourcePlayback, onMediaStream: setMediaStream }) })) : null, show && sourcePlayback && currentUser && backgroundConfig ? (_jsx(VirtualBackground, { sourcePlayback: sourcePlayback, backgroundConfig: backgroundConfig, id: currentUser })) : null, displayVB() ? _jsx(BackgroundItems, { onSelect: onSelectBg }) : null] }));
};
_react_refresh_temp_1 = PreviewWebcam;
$RefreshReg$(_react_refresh_temp_1, "PreviewWebcam");
_react_refresh_temp_2(PreviewWebcam, "HZjRXuo2NliId6cyyB90HOptj8U=", false, () => [useAppDispatch]);
export default PreviewWebcam;
